// queries/useImageGenerationStats.ts
"use client";
import { useQuery } from "@tanstack/react-query";
import { fetch } from "libs";
import { GET_IMAGE_GENERATION_STATS } from "api";
import { TimeWindow } from "conts/TimeWindows";

export interface ImageGenerationStat {
  image_id: string;
  user_id: string;
  checkpoint_id: string;
  duration_seconds: number;
  type: string; 
  created_at: string; 
  completed_at: string;
  status: string;
}

interface ImageGenerationStatsResponse {
  image_generations: ImageGenerationStat[];
}

export const fetchImageGenerationStats = async (timeWindow: TimeWindow): Promise<ImageGenerationStat[]> => {
  const response = await fetch(`${GET_IMAGE_GENERATION_STATS}?time_window=${timeWindow}`, {
    method: "GET",
  });
  const data: ImageGenerationStatsResponse = await response
  return data.image_generations;
};

const useImageGenerationStats = (timeWindow: TimeWindow) =>
  useQuery<ImageGenerationStat[]>({
    queryKey: ["imageGenerationStats", timeWindow],
    queryFn: () => fetchImageGenerationStats(timeWindow),
    refetchInterval: 5000,
  });

export default useImageGenerationStats;
